import { TRPCClientError, type TRPCLink } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import type { AppRouter } from "api";

export class SessionEndedError extends Error {
  constructor() {
    super("Data session has ended");
    this.name = "SessionEndedError";
  }
}

export function sessionLink(session: {
  signal: AbortSignal;
  isCurrent(): boolean;
}): TRPCLink<AppRouter> {
  return () =>
    ({ op, next }) =>
      observable((observer) => {
        const ended = () =>
          observer.error(TRPCClientError.from(new SessionEndedError()));
        if (!session.isCurrent()) {
          ended();
          return;
        }
        session.signal.addEventListener("abort", ended);
        const subscription = next(op).subscribe({
          next(value) {
            if (session.isCurrent()) observer.next(value);
            else ended();
          },
          error: (error) => observer.error(error),
          complete: () => observer.complete(),
        });
        return () => {
          session.signal.removeEventListener("abort", ended);
          subscription.unsubscribe();
        };
      });
}
